const ListarClientes = () => import('@/domains/shared/cadastros/clientes/views/Listar')
const AdicionarCliente = () => import('../views/Adicionar')
const EditarCliente = () => import('../views/Editar')
const VisualizarCliente = () => import('../views/Visualizar')
const ImportarCadastrosClientes = () => import('@/domains/shared/cadastros/clientes/views/Importar')
const routes = [
    {
        name: 'listarClientesEmissor',
        path: '/emissor/clientes',
        alias: ['/emissor/clientes/index'],
        component: ListarClientes,
    },
    {
        name: 'adicionarClientesEmissor',
        path: '/emissor/clientes/adicionar',
        component: AdicionarCliente,
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'editarClientesEmissor',
        path: '/emissor/clientes/editar/:id',
        component: EditarCliente,
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'visualizarClientesEmissor',
        path: '/emissor/clientes/visualizar/:id',
        component: VisualizarCliente,
    },
    {
        name: 'importarCadastrosClientesEmissor',
        path: '/emissor/clientes/importar_cadastros',
        component: ImportarCadastrosClientes,
    }
]

export default routes
